module.exports = __webpack_public_path__ + "static/media/left.c0ad1606.svg";